<template>
  <div class="content">
    <div class="row">
      <div class="col-12 col-md-8 ">
        <h3 class="mb-1">Consulter l'historique de vos transactions</h3>
        <p class="" v-if="conf.isPro">
          Chaque transaction enregistrée sur l'application est stockée et
          consultable à tout moment à partir d'ici.
        </p>
        <p class="" v-if="!conf.isPro">
          <i
            class="tim-icons icon-alert-circle-exc text-primary mr-2"
            aria-hidden="true"
          ></i>
          Vous ne pouvez consulter que les transactions de vos positions en
          cours.<br />
          <router-link class="pointer text-primary ml-4" tag="b" to="/pro">
            <b>Passer pro</b>
          </router-link>
          pour consulter toutes les transactions.
        </p>
      </div>
      <div class="col-12 col-md-4  text-right" v-if="conf.isPro">
        <base-input>
          <el-date-picker
            type="date"
            placeholder="Date de début"
            v-model="from"
          >
          </el-date-picker>
        </base-input>

        <base-input>
          <el-date-picker type="date" placeholder="Date de fin" v-model="to">
          </el-date-picker>
        </base-input>

        <div>
          <base-switch v-model="hideCurrentPosition">
            <i class="tim-icons icon-check-2" slot="on"></i>
            <i class="tim-icons icon-simple-remove" slot="off"></i>
          </base-switch>
          <span class="ml-3 align-top">Cacher les positions en cours</span>
        </div>

        <span
          @click="reloadHistory()"
          class="mt-0 text-center btn btn-sm btn-primary btn-simple"
        >
          Enregistrer
        </span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-4 col-md-6" v-for="card in statsCards" :key="card.key">
        <stats-card
          :title="card.title"
          :title-class="hideAmount ? 'text-blur' : ''"
          :sub-title="card.subTitle"
          :type="card.type"
          :icon="card.icon"
          :navTo="card.navTo"
        >
          <div slot="footer" v-html="card.footer"></div>
        </stats-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title"></h4>
          <div>
            <base-table :data="history" thead-classes="text-primary">
              <template slot="columns" slot-scope="{ columns }">
                <th class="text-center">
                  Date d'ouverture
                </th>
                <th class="text-center">
                  Date de fermeture
                </th>
                <th class="text-left">
                  Instrument
                </th>
                <th class="text-center">
                  Nb. de transactions
                </th>
                <th class="text-right">
                  ± values totales
                </th>
                <th class="text-center">actions</th>
              </template>
              <template slot-scope="{ row, index }" v-if="row">
                <td class="text-center">
                  {{ $moment(row.date_open * 1000).format("lll") }}
                </td>
                <td class="text-center">
                  {{
                    !row.date_close
                      ? "En cours"
                      : $moment(row.date_close * 1000).format("lll")
                  }}
                </td>
                <td class="text-left">{{ row.instrument.na }}</td>
                <td class="text-center">
                  <span class="text-success">
                    {{ row.nb_buy }} achat{{ row.nb_buy > 1 ? "s" : "" }}
                  </span>
                  &nbsp;
                  <span class="text-danger">
                    {{ row.nb_sell }} vente{{ row.nb_sell > 1 ? "s" : "" }}
                  </span>
                </td>
                <td
                  class="text-right"
                  v-bind:class="{
                    'text-danger': row.pv < 0,
                    'text-success': row.pv >= 0
                  }"
                >
                  {{ row.pv >= 0 ? "+" : ""
                  }}{{ row.pv | currency({ symbol: $currency(mode) }) }}
                </td>
                <td class="text-center pt-2">
                  <el-tooltip
                    content="Consulter les transactions"
                    effect="light"
                    :open-delay="200"
                    placement="top"
                  >
                    <base-button
                      type="primary"
                      icon
                      size="sm"
                      class="btn-link"
                      @click.native="
                        currentIndex = index;
                        historyModal = true;
                      "
                    >
                      <i class="tim-icons icon-cart"></i>
                    </base-button>
                  </el-tooltip>
                </td>
              </template>
            </base-table>
            <div class="text-center" v-if="history.length === 0">
              <b class="text-primary">Il ne se passe pas grand chose ici :) </b>
              <br />
              Votre historique de transactions sera rempli automatiquement en
              mettant à jour votre portefeuille.
            </div>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          ></div>
        </card>
      </div>
    </div>
    <modal
      :show-close="true"
      :show.sync="historyModal"
      class="modal-position"
      v-if="currentIndex >= 0"
    >
      <h4 slot="header">
        Historique des transactions
      </h4>
      <div class="modal-body">
        <base-table
          :data="history[currentIndex].history"
          v-if="!addTransactionPanel"
          thead-classes="text-primary"
        >
          <template slot="columns" slot-scope="{ columns }">
            <th class="text-center">
              Date
            </th>
            <th class="text-center">
              Type
            </th>
            <th class="text-center">
              Quantité
            </th>
            <th class="text-center">
              Prix
            </th>
            <th class="text-center">
              Montant
            </th>
          </template>
          <template slot-scope="{ row, index }" v-if="row">
            <td class="text-center">
              {{ $moment(row.t * 1000).format("lll") }}
            </td>
            <td
              class="text-center"
              v-bind:class="{
                'text-danger': row.s !== -1,
                'text-success': row.s === -1
              }"
            >
              {{ row.s === -1 ? "Achat" : "Vente" }}
            </td>
            <td class="text-center">
              {{ row.rq }}
            </td>
            <td class="text-center">
              {{
                row.rv
                  | currency({
                    symbol: $currency(mode),
                    fractionCount: history[currentIndex].instrument.pd
                  })
              }}
            </td>
            <td class="text-center">
              {{
                (row.rv * row.rq)
                  | currency({
                    symbol: $currency(mode)
                  })
              }}
            </td>
          </template>
        </base-table>
        <div v-if="addTransactionPanel">
          <div class="text-center text-muted">
            Indiquer le détail de votre position à une date données.<br />
            Les données d'achat/vente seront calculées automatiquement.<br />
            Si cette nouvelle position est liée à une vente, merci de préciser
            le prix de vente des titres concernés.
          </div>
          <div class="row">
            <div class="col-6">
              <label class="col-form-label">Date de la transaction</label>
              <base-input>
                <el-date-picker
                  type="date"
                  placeholder="Date de fin"
                  v-model="newTransaction.t"
                >
                </el-date-picker>
              </base-input>
              <label class="col-form-label">Nouvelle quantité totale</label>
              <base-input
                name="quantity"
                v-model="newTransaction.q"
                placeholder="Quantité"
                type="number"
                step="any"
              >
              </base-input>
            </div>
            <div class="col-6">
              <label class="col-form-label">Nouveau PRU</label>
              <base-input
                name="value"
                v-model="newTransaction.v"
                placeholder="PRU"
                type="number"
                step="any"
              >
              </base-input>

              <label class="col-form-label">Prix de vente (facultatif)</label>
              <base-input
                name="value"
                v-model="newTransaction.s"
                placeholder="Prix de vente"
                type="number"
                step="any"
              >
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <span
              @click="addTransaction()"
              class="mt-0 text-center btn btn-sm btn-warning btn-simple"
            >
              Ajouter la transaction
            </span>
          </div>
        </div>
        <!-- <div class="text-warning text-center">
          <small
            class="pointer"
            @click="addTransactionPanel = !addTransactionPanel"
            >{{
              addTransactionPanel ? "Annuler" : "Ajouter une transaction"
            }}</small
          >
        </div> -->
      </div>
    </modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { BaseSwitch, BaseTable, Modal } from "@/components";
import { getHistory } from "../../dao/firestore";
import { DatePicker } from "element-ui";
import StatsCard from "src/components/Cards/StatsCard";

export default {
  components: {
    StatsCard,
    BaseSwitch,
    BaseTable,
    [DatePicker.name]: DatePicker,
    Modal
  },
  computed: {
    ...mapGetters({
      livelist: "instruments/livelist",
      conf: "auth/conf",
      user: "auth/user",
      mode: "auth/mode"
    }),
    cur() {
      return this.mode === "pea" ? "€" : "$";
    }
  },
  data() {
    return {
      addTransactionPanel: false,
      newTransaction: {
        t: new Date(),
        q: 0,
        s: 0,
        v: 0
      },
      hideCurrentPosition: false,
      loadedPosition: [],
      from: null,
      to: null,
      history: [],
      currentIndex: -1,
      historyModal: false,
      statsCards: [
        {
          key: "Total Gains",
          title: "0€",
          subTitle: "Gain de",
          type: "success",
          icon: "tim-icons icon-money-coins",
          footer:
            'Gains moyen de <span class="text-success">0€</span> par position'
        },
        {
          key: "ratio",
          title: "42%",
          subTitle: "Pos. gagnantes / Nombre de pos.",
          type: "primary",
          icon: "tim-icons icon-chart-pie-36",
          footer: '<span class="text-success">8/12</span> positions gagnantes'
        },
        {
          key: "transaction",
          title: "19",
          subTitle: "Nombre de transactions",
          type: "info",
          icon: "tim-icons icon-delivery-fast",
          footer: "En moyenne 2 transactions par position"
        }
      ]
    };
  },
  methods: {
    async reloadHistory() {
      if (!this.livelist.length) return;

      const loadedPosition = this.conf.isPro
        ? await getHistory(
            this.user,
            this.mode,
            +this.from / 1000,
            +this.to / 1000
          )
        : [];
      const currentPositions = this.hideCurrentPosition
        ? []
        : this.conf.positions.filter(p => p.history);

      const positions = [...currentPositions, ...loadedPosition];
      this.history = positions
        .map(c => {
          const instrument = this.livelist.find(l => l.isin === c.isin);
          let pv = 0;
          for (let [i, h] of c.history.entries()) {
            // Quantité réelle
            if (i > 0) {
              h.rq = Math.abs(h.q - c.history[i - 1].q);
            } else {
              h.rq = h.q;
            }

            // Prix d'achat
            if (i > 0) {
              if (h.s !== -1) {
                h.rv = h.s;
                pv += h.rv * h.rq;
              } else {
                h.rv =
                  (h.v * h.q - c.history[i - 1].v * c.history[i - 1].q) / h.rq;
                pv -= h.rv * h.rq;
              }
            } else {
              h.rv = h.v;
              pv -= h.rv * h.rq;
            }

            // Current position, add the real value
            // maybe use something else than the last value
            if (c.history[c.history.length - 1].q !== 0) {
              pv += h.rq * instrument.li.last;
            }
          }

          return {
            date_open: c.history[0].t,
            date_close:
              c.history[c.history.length - 1].q === 0
                ? c.history[c.history.length - 1].t
                : null,
            instrument,
            nb_buy: c.history.filter(h => h.s === -1).length,
            nb_sell: c.history.filter(h => h.s !== -1).length,
            pv: pv,
            history: c.history,
            position: c
          };
        })
        .sort((a, b) => b.date_open - a.date_open);

      this.updateStats();
    },
    addTransaction() {
      const position = this.history[this.currentIndex].position;
      console.log("addTransaction", position);
      const transaction = {
        q: parseFloat(this.newTransaction.q),
        v: parseFloat(this.newTransaction.v),
        s: parseFloat(this.newTransaction.s),
        t: +this.newTransaction.t / 1000
      };
      if (transaction.s === 0) {
        transaction.s = -1;
      }
      if (!position.uid) {
        // Add position to current user conf
        this.$store.dispatch("auth/addPositionHistory", {
          isin: position.isin,
          transaction
        });
      } else {
        // Add transaction to history record
      }
      this.newTransaction = {
        t: new Date(),
        q: 0,
        s: 0,
        v: 0
      };
      this.addTransactionPanel = false;
    },
    updateStats() {
      const stats = {
        pv: 0,
        nbTransactions: 0,
        nbPositions: 0,
        winPos: 0,
        lossPos: 0
      };
      stats.nbPositions = this.history.length;
      this.history.forEach(h => {
        stats.pv += h.pv;
        stats.nbTransactions += h.history.length;
        if (h.pv > 0) {
          stats.winPos++;
        } else {
          stats.lossPos++;
        }
      });
      // Gains moyens
      this.statsCards[0] = {
        key: "Total Gains",
        title: `${stats.pv < 0 ? "-" : ""}${this.$options.filters.currency(
          stats.pv,
          {
            symbol: this.cur
          }
        )}`,
        subTitle: "± values de",
        type: "success",
        icon: "tim-icons icon-money-coins",
        footer: `± values moyennes de <b class="${
          stats.pv < 0 ? "text-danger" : "text-success"
        }">${stats.pv < 0 ? "-" : ""}${this.$options.filters.currency(
          stats.pv / stats.nbPositions,
          {
            symbol: this.cur
          }
        )}</b> par position`
      };
      this.statsCards[1] = {
        key: "ratio",
        title: `${parseInt((stats.winPos / stats.nbPositions) * 100)}%`,
        subTitle: "Pourcentage de pos. gagnantes",
        type: "primary",
        icon: "tim-icons icon-chart-pie-36",
        footer: `<b class="${
          stats.winPos < stats.lossPos ? "text-danger" : "text-success"
        }">${stats.winPos}/${stats.nbPositions}</b> positions gagnantes`
      };
      this.statsCards[2] = {
        key: "transaction",
        title: stats.nbTransactions,
        subTitle: "Nombre de transactions",
        type: "info",
        icon: "tim-icons icon-delivery-fast",
        footer: `En moyenne ${(
          stats.nbTransactions / stats.nbPositions
        ).toFixed(2)} transactions par position`
      };
    }
  },
  async mounted() {
    this.from = new Date();
    this.from.setDate(this.from.getDate() - 60);
    this.to = new Date();
    await this.reloadHistory();
  },
  watch: {
    async livelist(newValue, oldValue) {
      await this.reloadHistory();
    },
    async conf(newValue, oldValue) {
      await this.reloadHistory();
    }
  },
  metaInfo() {
    return {
      title: "Track record"
    };
  }
};
</script>
<style></style>
